// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.detailsRemitos_container__YLXWa {
  animation: detailsRemitos_init__dnVOq 1s;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  max-width: 80%;
  margin-bottom: 50px;
}

/*---Title---*/
.detailsRemitos_container__YLXWa .detailsRemitos_titleContainer__KJhoR {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.detailsRemitos_container__YLXWa .detailsRemitos_arrow__gVQlQ {
  transition: 0.3s;
}

.detailsRemitos_container__YLXWa .detailsRemitos_arrow__gVQlQ:hover {
  transition: 0.3s;
  scale: 1.05;
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 100%;
  cursor: pointer;
}

.detailsRemitos_container__YLXWa {
  justify-content: center;
}

.detailsRemitos_container__YLXWa .detailsRemitos_init__dnVOq {
  animation: detailsRemitos_init__dnVOq 0.3s 0.5s both;
}

.detailsRemitos_container__YLXWa .detailsRemitos_item__jCmn5 h4 {
  font-size: 1.2rem;
  font-weight: 400;
  margin-bottom: 5px;
}

.detailsRemitos_container__YLXWa .detailsRemitos_item__jCmn5 p {
  font-size: 1.1rem;
  font-weight: 300;
  margin: 0;
  margin-top: 5px;
}

.detailsRemitos_container__YLXWa .detailsRemitos_address__0d4PV {
  font-size: 1rem;
  font-weight: 400;
  margin: 0;
  margin-top: 3px;
  opacity: 0.7;
}

.detailsRemitos_container__YLXWa .detailsRemitos_tableContainer__h5yps {
  animation: detailsRemitos_init__dnVOq 0.3s;
  border-radius: 5px;
  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.129);
}

@keyframes detailsRemitos_init__dnVOq {
  0% {
    opacity: 0;
    transform: translateX(-20px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/Remitos/Details/detailsRemitos.module.css"],"names":[],"mappings":"AAAA;EACE,wCAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oDAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,YAAY;AACd;;AAEA;EACE,0CAAoB;EACpB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":[".container {\n  animation: init 1s;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  max-width: 80%;\n  margin-bottom: 50px;\n}\n\n/*---Title---*/\n.container .titleContainer {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.container .arrow {\n  transition: 0.3s;\n}\n\n.container .arrow:hover {\n  transition: 0.3s;\n  scale: 1.05;\n  background-color: rgba(0, 0, 0, 0.05);\n  border-radius: 100%;\n  cursor: pointer;\n}\n\n.container {\n  justify-content: center;\n}\n\n.container .init {\n  animation: init 0.3s 0.5s both;\n}\n\n.container .item h4 {\n  font-size: 1.2rem;\n  font-weight: 400;\n  margin-bottom: 5px;\n}\n\n.container .item p {\n  font-size: 1.1rem;\n  font-weight: 300;\n  margin: 0;\n  margin-top: 5px;\n}\n\n.container .address {\n  font-size: 1rem;\n  font-weight: 400;\n  margin: 0;\n  margin-top: 3px;\n  opacity: 0.7;\n}\n\n.container .tableContainer {\n  animation: init 0.3s;\n  border-radius: 5px;\n  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.129);\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n    transform: translateX(-20px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `detailsRemitos_container__YLXWa`,
	"init": `detailsRemitos_init__dnVOq`,
	"titleContainer": `detailsRemitos_titleContainer__KJhoR`,
	"arrow": `detailsRemitos_arrow__gVQlQ`,
	"item": `detailsRemitos_item__jCmn5`,
	"address": `detailsRemitos_address__0d4PV`,
	"tableContainer": `detailsRemitos_tableContainer__h5yps`
};
export default ___CSS_LOADER_EXPORT___;
